<script setup lang="ts">

import Ringworld from '@/components/Sections/Resources/Elements/Ringworld.vue'
import { useOreConversionStore } from '@/stores/oreConversionStore.ts'
import { computed } from 'vue'
import { useGameStore } from '@/stores/gameStore.ts'

const oreConversionStore = useOreConversionStore()
const gameStore = useGameStore()

const data = computed(() => {
  const ringworldOreId = gameStore.player?.ringworldOreId
  if (!ringworldOreId) {
    // Default fallback if no ringworld ore is set
    return { ore: 1, left: 2, conveyorType: 'left' }
  }
  return oreConversionStore.getOreVisualDataFromOreId(ringworldOreId)
})

</script>

<template>
  <Ringworld
    v-if="gameStore.player?.ringworldOreId"
    :ore="data.ore"
    :processed="oreConversionStore.data.ringworld"
    :top="90"
    :left="data.left"
    :height="5"
    :width="8"
    :conveyor-type="data.conveyorType"
    :debug="false"
  ></Ringworld>
</template>

<style scoped lang="scss">

</style> 